/**
 * Tiny, dependency-free bridge between the upload service and the toast layer.
 *
 * When an admin has turned on upload review (Media Library → Review queue → Upload review), the
 * Worker answers `202 Accepted` instead of `201 Created`: the file is safely stored but NOT public
 * until a master admin approves it. The upload functions still return the URL the file will have
 * once approved (so the record that saved it keeps working the moment it is), and they announce
 * this event so the UI can say plainly that the upload is waiting — instead of a bare "Uploaded"
 * followed by a picture that does not show.
 *
 * A DOM event rather than an import so `toast.tsx` (eagerly loaded, part of the UI kit) does not
 * pull the Firebase-dependent storage service into its dependency graph.
 */
export const MEDIA_PENDING_EVENT = 'gocricket:media-pending-review'

export type PendingMediaKind = 'image' | 'video'

export function announcePendingReview(kind: PendingMediaKind): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(MEDIA_PENDING_EVENT, { detail: { kind } }))
}

export function pendingReviewMessage(kind: PendingMediaKind): string {
  return kind === 'video'
    ? 'Video submitted for review — it will not play for viewers until an admin approves it.'
    : 'Image submitted for review — it will appear once an admin approves it.'
}
